import React, { useState } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { toast } from "react-toastify";
import { useSelector, useDispatch } from 'react-redux';

import {myProfileUpdate} from "../../Redux/Settings/myProfile/actions";



export default function MyProfile() {

  const dispatch = useDispatch();
  const [validated, setValidated] = useState(false);
  const user = useSelector(state => state.authReducer.data)
  const tokens = useSelector(state => state.authReducer.tokens)
  const [formData, setFormData] = useState({
    name: user.name,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const toastConfig = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 2500,
};

  const handleSubmit = async (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      toast.error("Please fill all the fields", toastConfig);
    }
    else{

      await myProfileUpdate(dispatch, user.id, formData);
    }
  };


  return (
    <Container className='mt-5 p-3'>
      <Row>
        <Col>
              <div>
                <h4 className='main-h4-tag-large'>Your Profile</h4>
                <Form noValidate validated={validated} onSubmit={handleSubmit} className=' w-75' >
                  <Form.Group controlId="formName" className='mt-3 custom-p-tag'>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <Form.Group controlId="formEmail" className='mt-3 custom-p-tag '>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <Form.Group controlId="formName" className='mt-3 custom-p-tag'>
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Phone Number"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                     required
                    />
                  </Form.Group>
                  {/*<Form.Group controlId="formName" className='mt-3 custom-p-tag '>*/}
                  {/*  <Form.Label>New Password</Form.Label>*/}
                  {/*  <Form.Control*/}
                  {/*    type="text"*/}
                  {/*    placeholder="Enter New Password"*/}
                  {/*    name="password"*/}
                  {/*    value={formData.password}*/}
                  {/*    onChange={handleChange}*/}
                  {/*    required*/}
                  {/*  />*/}
                  {/*</Form.Group>*/}
                  <Button variant="primary" type="submit" className='custom-button mt-4'>
                    Update
                  </Button>
                </Form>
              </div>
        </Col >
      </Row>
    </Container>
  )
}
